import styled from 'styled-components';
import { BooksLogoTitleProps, FormButtonsContainerProps, LogosBlockProps } from './types';

export const MainpageContainer = styled.div`
  width: 100%;
  padding-top: 50px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: linear-gradient(0deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0) 85%, #dddfde),
    url('/mainpage-books.jpg') 50% no-repeat;
  background-size: cover;
  height: 100vh;
`;

export const MainpageUI = styled.div`
  width: 100%;
  max-width: 1240px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
`;

export const LogosBlock = styled.div<LogosBlockProps>`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: ${(props) => props.small && '0 10px'};

  .burger-menu {
    width: 38px;
    height: 30px;

    cursor: pointer;
    border: 0;
    background: transparent;

    svg {
      fill: #378dda;
      stroke: #103556;
    }
  }
`;

export const BooksLogoTitle = styled.div<BooksLogoTitleProps>`
  width: auto;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 10px;

  svg {
    width: 57px;
    height: 100%;
  }

  h1 {
    font-weight: 900;
    font-size: ${(props) => (props.small ? '20px' : '32px')};
    line-height: 1.1em;
    color: black;
    margin: 0;

    width: ${(props) => (props.small ? '100px' : '400px')};
  }

  img {
    width: 50px;
    height: 60px;
  }

  .gerb-title {
    width: 250px;
    line-height: 14px;
    font-size: 13px;
    text-transform: uppercase;
    margin: 0;
    color: black;
  }
`;

export const MainpageFormContainer = styled.div`
  width: 100%;
  background: linear-gradient(180deg, #f9f9f9 0%, #fcfcfc 0.01%, #f6f7f7 100%);
  padding: 90px 30px 0 30px;

  .left-side {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const FormButtonsContainer = styled.div<FormButtonsContainerProps>`
  width: 100%;
  padding-top: 40px;
  padding-bottom: 20px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;

  button {
    width: ${(props) => props.responsible && '300px'};
    max-width: ${(props) => props.responsible && '300px'};
  }
`;

export const AdvancedSearchBlock = styled.div`
  width: 100%;

  display: flex;
  gap: 10px;

  .label {
    color: #1064a3;
    text-decoration: underline;
    margin: 0;
    cursor: pointer;

    padding: 0;

    background: none;
    border: none;
  }
`;

export const AdvancedSearchPopup = styled.button`
  background: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 1px solid #1064a3;
  cursor: pointer;

  color: #1064a3;

  display: flex;

  justify-content: center;
  align-items: center;
`;

export const AdditionalFiltersContainer = styled.div`
  width: 100%;
  border-top: 1px solid #e2e2e2;
  padding: 20px 0;
  margin-top: 20px;
`;
